import { z } from 'zod';

const optionalText = (max: number) =>
  z
    .string()
    .trim()
    .max(max)
    .optional()
    .transform((v) => (v === '' ? undefined : v));

export const createLocationInputSchema = z.object({
  name: z.string().trim().min(1).max(200),
  code: optionalText(20),
  description: optionalText(1000),
});
export type CreateLocationInput = z.infer<typeof createLocationInputSchema>;

export const updateLocationInputSchema = createLocationInputSchema
  .partial()
  .extend({ isActive: z.boolean().optional() });
export type UpdateLocationInput = z.infer<typeof updateLocationInputSchema>;

export const locationSchema = z.object({
  id: z.string().uuid(),
  companyId: z.string().uuid(),
  name: z.string(),
  code: z.string().nullable(),
  description: z.string().nullable(),
  isActive: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Location = z.infer<typeof locationSchema>;

export const createClassInputSchema = createLocationInputSchema;
export type CreateClassInput = z.infer<typeof createClassInputSchema>;

export const updateClassInputSchema = updateLocationInputSchema;
export type UpdateClassInput = z.infer<typeof updateClassInputSchema>;

export const classSchema = locationSchema;
export type Class = z.infer<typeof classSchema>;
